import { render, staticRenderFns } from "./employeecontent.vue?vue&type=template&id=6dc0b0ca"
import script from "./employeecontent.vue?vue&type=script&lang=js"
export * from "./employeecontent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports